import StopSimCardAddRemarkModal from './stop-sim-card-add-remark-modal.vue'
export default StopSimCardAddRemarkModal
